
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsultantsStatsFromView"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_consultants_stats_from_view"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consultant_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"consultant_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"positives_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"negatives_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"informationneeded_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validated_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from_this_morning_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from_this_morning_impossible"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from_this_morning_positives_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from_this_morning_negatives_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from_this_morning_informationneeded_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from_this_morning_validated_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"today_recived_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"today_impossible_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"today_written_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"today_published_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"today_signaled_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"today_information_needed_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seven_day_recived_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seven_day_impossible_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seven_day_written_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seven_day_published_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seven_day_signaled_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seven_day_information_needed_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thirty_day_recived_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thirty_day_impossible_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thirty_day_written_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thirty_day_published_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thirty_day_signaled_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thirty_day_information_needed_count"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":993}};
    doc.loc.source = {"body":"query ConsultantsStatsFromView {\r\n  get_consultants_stats_from_view {\r\n    consultant_id\r\n    consultant_name\r\n    positives_count\r\n    negatives_count\r\n    informationneeded_count\r\n    validated_count\r\n    from_this_morning_count\r\n    from_this_morning_impossible\r\n    from_this_morning_positives_count\r\n    from_this_morning_negatives_count\r\n    from_this_morning_informationneeded_count\r\n    from_this_morning_validated_count\r\n    today_recived_count\r\n    today_impossible_count\r\n    today_written_count\r\n    today_published_count\r\n    today_signaled_count\r\n    today_information_needed_count\r\n    seven_day_recived_count\r\n    seven_day_impossible_count\r\n    seven_day_written_count\r\n    seven_day_published_count\r\n    seven_day_signaled_count\r\n    seven_day_information_needed_count\r\n    thirty_day_recived_count\r\n    thirty_day_impossible_count\r\n    thirty_day_written_count\r\n    thirty_day_published_count\r\n    thirty_day_signaled_count\r\n    thirty_day_information_needed_count\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ConsultantsStatsFromView"] = oneQuery(doc, "ConsultantsStatsFromView");
        
